"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetState = exports.replaceFilters = exports.clearFilter = exports.toggleFilter = exports.playForFun = exports.resetGame = exports.endDigitalArcadeGameData = exports.endNGLGameFun = exports.startNGLGameFun = exports.startNGLGameSessionFun = exports.endNGLGame = exports.startNGLGame = exports.startNGLGameSession = exports.getNGLToken = exports.getNGLGameData = exports.fetchDenominations = exports.getDigitalArcadeGameData = exports.debitArcadeGameV2 = exports.debitArcadeGame = exports.fetchArcadeGame = exports.fetchArcadeGames = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/arcades/types");
var types_2 = require("@pbl/pbl-react-core/lib/models/games/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var action_type_util_1 = require("../../../redux/action-type.util");
var actions_1 = require("../../../redux/reducers/app/actions");
var actions_2 = require("../../../redux/reducers/authentication/actions");
var actions_3 = require("../../../redux/reducers/ledger/actions");
var FilterActions = __importStar(require("../../../shared/components/filters/filters.actions"));
var fetchArcadeGames = function (sort) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_ARCADE_GAMES,
                        payload: services_1.ArcadeService.getArcadeGames(sort)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchArcadeGames = fetchArcadeGames;
var fetchArcadeGame = function (gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var id, payload, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                id = parseInt(gameId, 10);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.GET_ARCADE)
                });
                return [4, services_1.GamesService.getPublishedGame(id)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_ARCADE),
                    payload: payload
                });
                if (!(payload.vendor === types_2.GameVendor.PBL)) return [3, 3];
                return [4, dispatch((0, exports.fetchDenominations)(payload.gameId))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3: return [4, dispatch((0, exports.getNGLGameData)(payload.gameId))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3, 7];
            case 6:
                error_2 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.GET_ARCADE),
                    payload: error_2
                });
                console.error(error_2);
                return [3, 7];
            case 7: return [2];
        }
    });
}); }; };
exports.fetchArcadeGame = fetchArcadeGame;
var debitArcadeGame = function (denomination, gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.DEBIT_ARCADE)
                });
                return [4, services_1.SweepstakesService.debitArcade(denomination, gameId)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.DEBIT_ARCADE),
                    payload: payload
                });
                return [4, dispatch((0, actions_3.fetchUserTokens)())];
            case 2:
                _a.sent();
                if (!(payload.prizes && payload.prizes.length > 0 && payload.prizes[0].digitalRevealToken)) return [3, 4];
                return [4, dispatch((0, exports.getDigitalArcadeGameData)(payload.prizes[0].digitalRevealToken))];
            case 3:
                _a.sent();
                return [3, 5];
            case 4:
                dispatch((0, actions_1.showMessageBar)({ message: 'Error loading game, please try again', type: 'error' }));
                _a.label = 5;
            case 5: return [3, 7];
            case 6:
                error_3 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.DEBIT_ARCADE),
                    payload: error_3
                });
                console.error(error_3);
                return [3, 7];
            case 7: return [2];
        }
    });
}); }; };
exports.debitArcadeGame = debitArcadeGame;
var debitArcadeGameV2 = function (denomination, gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.DEBIT_ARCADE)
                });
                return [4, services_1.SweepstakesService.debitArcadeV2(denomination, gameId)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.DEBIT_ARCADE),
                    payload: payload
                });
                return [4, dispatch((0, actions_3.fetchUserTokens)())];
            case 2:
                _a.sent();
                if (!(payload.prizes && payload.prizes.length > 0 && payload.prizes[0].digitalRevealToken)) return [3, 4];
                return [4, dispatch((0, exports.getDigitalArcadeGameData)(payload.prizes[0].digitalRevealToken))];
            case 3:
                _a.sent();
                return [3, 5];
            case 4:
                dispatch((0, actions_1.showMessageBar)({ message: 'Error loading game, please try again', type: 'error' }));
                _a.label = 5;
            case 5: return [3, 7];
            case 6:
                error_4 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.DEBIT_ARCADE),
                    payload: error_4
                });
                console.error(error_4);
                return [3, 7];
            case 7: return [2];
        }
    });
}); }; };
exports.debitArcadeGameV2 = debitArcadeGameV2;
var getDigitalArcadeGameData = function (token) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_DIGITAL_REVEAL_ARCADE,
                        payload: services_1.SweepstakesService.getArcadeGameData(token)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_5 = _a.sent();
                console.error(error_5);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getDigitalArcadeGameData = getDigitalArcadeGameData;
var fetchDenominations = function (gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_ARCADE_DENOMINATIONS,
                        payload: services_1.SweepstakesService.getDenominations(gameId)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_6 = _a.sent();
                console.error(error_6);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchDenominations = fetchDenominations;
var getNGLGameData = function (gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.GET_NGL_GAME_DATA)
                });
                return [4, services_1.NGLService.getNGLGameData(gameId)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_NGL_GAME_DATA),
                    payload: payload
                });
                return [3, 3];
            case 2:
                error_7 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.GET_NGL_GAME_DATA),
                    payload: error_7
                });
                console.error(error_7);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getNGLGameData = getNGLGameData;
var getNGLToken = function (sendToNGL) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenResponse, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4, dispatch((0, actions_2.isAuthenticated)())];
            case 1:
                _a.sent();
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.SET_NGL_TOKEN)
                });
                return [4, services_1.NGLService.getPBLToken()];
            case 2:
                tokenResponse = _a.sent();
                if (!(tokenResponse && sendToNGL)) return [3, 4];
                return [4, services_1.NGLService.setNGLToken(tokenResponse.subjectToken)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.SET_NGL_TOKEN),
                    payload: tokenResponse
                });
                return [3, 6];
            case 5:
                error_8 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.SET_NGL_TOKEN),
                    payload: error_8
                });
                console.error(error_8);
                return [3, 6];
            case 6: return [2];
        }
    });
}); }; };
exports.getNGLToken = getNGLToken;
var startNGLGameSession = function (gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.START_NGL_GAME_SESSION)
                });
                return [4, services_1.NGLService.startNGLGameSession(gameId)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.START_NGL_GAME_SESSION),
                    payload: {
                        clientRequestToken: payload.clientRequestToken,
                        clientSessionId: payload.clientSessionId
                    }
                });
                return [3, 3];
            case 2:
                error_9 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.START_NGL_GAME_SESSION),
                    payload: error_9
                });
                console.error(error_9);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.startNGLGameSession = startNGLGameSession;
var startNGLGame = function (gameId, wager) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionDataNGL, payload, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 7]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.START_NGL_GAME)
                });
                sessionDataNGL = getState().arcades.sessionDataNGL;
                if (!sessionDataNGL) {
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.START_NGL_GAME),
                        payload: 'No Session found for the game.'
                    });
                    return [2];
                }
                return [4, services_1.NGLService.startNGLGame(gameId, wager, sessionDataNGL.clientSessionId, sessionDataNGL.clientRequestToken)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.START_NGL_GAME),
                    payload: payload
                });
                return [3, 7];
            case 2:
                error_10 = _a.sent();
                if (!(error_10 && error_10.payload && error_10.payload.status === 403)) return [3, 5];
                return [4, dispatch((0, exports.getNGLToken)(true))];
            case 3:
                _a.sent();
                return [4, dispatch((0, exports.startNGLGame)(gameId, wager))];
            case 4:
                _a.sent();
                return [3, 6];
            case 5:
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.START_NGL_GAME),
                    payload: error_10
                });
                _a.label = 6;
            case 6: return [3, 7];
            case 7: return [2];
        }
    });
}); }; };
exports.startNGLGame = startNGLGame;
var endNGLGame = function (gameId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionDataNGL, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                sessionDataNGL = getState().arcades.sessionDataNGL;
                if (!sessionDataNGL) {
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.END_NGL_GAME),
                        payload: 'No Session found for the game.'
                    });
                    return [2];
                }
                return [4, dispatch({
                        type: types_1.END_NGL_GAME,
                        payload: services_1.NGLService.endNGLGame(gameId, sessionDataNGL.clientSessionId, sessionDataNGL.clientRequestToken)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_11 = _a.sent();
                console.error(error_11);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.endNGLGame = endNGLGame;
var startNGLGameSessionFun = function (gameId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionDataNGLFun, payload, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sessionDataNGLFun = getState().arcades.sessionDataNGLFun;
                if (!!sessionDataNGLFun) return [3, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.START_NGL_GAME_SESSION_FUN)
                });
                return [4, services_1.NGLService.startNGLGameSession(gameId, true)];
            case 2:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.START_NGL_GAME_SESSION_FUN),
                    payload: {
                        clientRequestToken: payload.clientRequestToken,
                        clientSessionId: payload.clientSessionId
                    }
                });
                return [3, 4];
            case 3:
                error_12 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.START_NGL_GAME_SESSION_FUN),
                    payload: error_12
                });
                console.error(error_12);
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.startNGLGameSessionFun = startNGLGameSessionFun;
var startNGLGameFun = function (gameId, wager) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionDataNGLFun, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                sessionDataNGLFun = getState().arcades.sessionDataNGLFun;
                if (!sessionDataNGLFun) {
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.START_NGL_GAME_FUN),
                        payload: 'No Session found for the game.'
                    });
                    return [2];
                }
                return [4, dispatch({
                        type: types_1.START_NGL_GAME_FUN,
                        payload: services_1.NGLService.startNGLGame(gameId, wager, sessionDataNGLFun.clientSessionId, sessionDataNGLFun.clientRequestToken, true)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_13 = _a.sent();
                console.error(error_13);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.startNGLGameFun = startNGLGameFun;
var endNGLGameFun = function (gameId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionDataNGLFun, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                sessionDataNGLFun = getState().arcades.sessionDataNGLFun;
                if (!sessionDataNGLFun) {
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.START_NGL_GAME_FUN),
                        payload: 'No Session found for the game.'
                    });
                    return [2];
                }
                return [4, dispatch({
                        type: types_1.END_NGL_GAME_FUN,
                        payload: services_1.NGLService.endNGLGame(gameId, sessionDataNGLFun.clientSessionId, sessionDataNGLFun.clientRequestToken, true)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_14 = _a.sent();
                console.error(error_14);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.endNGLGameFun = endNGLGameFun;
var endDigitalArcadeGameData = function (token) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.END_DIGITAL_REVEAL_ARCADE,
                        payload: services_1.InteractiveGameService.endGame(token)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_15 = _a.sent();
                console.error(error_15);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.endDigitalArcadeGameData = endDigitalArcadeGameData;
var resetGame = function () { return function (dispatch) {
    dispatch((0, actions_1.clearMessages)());
    dispatch({
        type: types_1.RESET_ARCADE
    });
}; };
exports.resetGame = resetGame;
var playForFun = function (gameId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, error_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4, services_1.SweepstakesService.playForFun(gameId)];
            case 1:
                payload = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.PLAY_FOR_FUN),
                    payload: payload
                });
                if (!(payload.prizes && payload.prizes.length > 0 && payload.prizes[0].digitalRevealToken)) return [3, 3];
                return [4, dispatch((0, exports.getDigitalArcadeGameData)(payload.prizes[0].digitalRevealToken))];
            case 2:
                _a.sent();
                return [3, 4];
            case 3:
                dispatch((0, actions_1.showMessageBar)({ message: 'Error loading game, please try again', type: 'error' }));
                _a.label = 4;
            case 4: return [3, 6];
            case 5:
                error_16 = _a.sent();
                console.error('playForFun Error: ', error_16);
                return [3, 6];
            case 6: return [2];
        }
    });
}); }; };
exports.playForFun = playForFun;
var toggleFilter = function (entityName, sectionKey, filterKey) { return function (dispatch) {
    dispatch(FilterActions.toggleFilter(entityName, sectionKey, filterKey));
}; };
exports.toggleFilter = toggleFilter;
var clearFilter = function () { return function (dispatch) {
    dispatch(FilterActions.clearFilter('arcade'));
}; };
exports.clearFilter = clearFilter;
var replaceFilters = function (filters) { return function (dispatch) {
    dispatch(FilterActions.replaceFilers('arcade', filters));
}; };
exports.replaceFilters = replaceFilters;
var resetState = function () { return function (dispatch) {
    dispatch({
        type: types_1.RESET_STATE
    });
}; };
exports.resetState = resetState;
//# sourceMappingURL=actions.js.map